import React, { useContext, useState } from 'react'
import { node } from 'prop-types'
import { EmailSignUpFloaterBar } from '../EmailSignUpFloaterBar'
import { isBrowser } from '@jelly/utils'
import { SiteConfigContext } from '../SiteConfigProvider'

export const EmailSubscribeContext = React.createContext()

/**
 * This provider wraps the root of both BDC and BND
 * It provides context to handle the logic for the email capture floater bar as well as the subscribe button
 */
export function EmailSubscribeProvider({ children }) {
	const defaultEmailFormSubmissionState = false
	const [emailSubscribeFormSubmitted, setEmailSubscribeFormSubmitted] = useState(() => {
		try {
			if (isBrowser()) {
				const item = window.sessionStorage.getItem('emailSubscriptionEnabled')
				// Parse stored json or if none return defaultEmailFormSubmissionState
				return item ? JSON.parse(item) : defaultEmailFormSubmissionState
			} else {
				return defaultEmailFormSubmissionState
			}
		} catch (error) {
			// If error also return defaultEmailFormSubmissionState
			console.error('sessionstorage', error)
			return defaultEmailFormSubmissionState
		}
	})

	const {
		siteConstants: {
			EMAIL_CAPTURE_SOURCES: { homepage },
		},
	} = useContext(SiteConfigContext)
	const [emailSubscribeSource, setEmailSubscribeSource] = useState(homepage)
	const [isVisible, setIsVisible] = useState(false)
	const [isScrollListenerEnabled, setIsScrollListenerEnabled] = useState(false) // defaulting to false here because we only want to enable floater bar to show up on scroll for homepage, articles with no widget, and hubs with no sponsor

	return (
		<EmailSubscribeContext.Provider
			value={{
				emailSubscribeSource,
				emailSubscribeFormSubmitted,
				isVisible,
				isScrollListenerEnabled,
				setEmailSubscribeFormSubmitted,
				setEmailSubscribeSource,
				setIsVisible,
				setIsScrollListenerEnabled,
			}}
		>
			{children}
			<EmailSignUpFloaterBar source={emailSubscribeSource} />
		</EmailSubscribeContext.Provider>
	)
}
EmailSubscribeProvider.propTypes = {
	children: node,
}
